var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ERROR_MESSAGE_KEY, Metric, Trace, Log, } from '@amzn/showtime';
import { allSettled, isFulfilledPromise, isRejectedPromise, } from '../polyfills';
import TENANT_ID from '../TenantId';
const logger = Log(TENANT_ID);
export default function bootstrapTenants({ bootstrapFunctions, bootstrapProps, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const trace = Trace('BootstrapTenants', TENANT_ID);
        const promises = bootstrapFunctions.map((bootstrapFunction) => new Promise((resolve) => {
            const tenant = bootstrapFunction(bootstrapProps);
            resolve(tenant);
        }));
        let results = [];
        try {
            results = yield allSettled(promises);
        }
        catch (err) {
            logger.error('InternalBootstrappingError', { error: err });
            let errorMessage = '';
            if (err instanceof Error) {
                errorMessage = err === null || err === void 0 ? void 0 : err.message;
            }
            const attributes = { [ERROR_MESSAGE_KEY]: errorMessage };
            Metric('InternalBootstrappingError', TENANT_ID, { attributes }).put();
        }
        const rejected = results.filter(isRejectedPromise);
        rejected.forEach((r) => {
            var _a;
            const attributes = { [ERROR_MESSAGE_KEY]: (_a = r.reason) === null || _a === void 0 ? void 0 : _a.message };
            Metric('TenantBootstrappingError', TENANT_ID, { attributes }).put();
        });
        const availableTenants = results.filter(isFulfilledPromise).map((r) => r.value);
        const placements = [];
        availableTenants.forEach((t) => {
            placements.push(...t.placements);
        });
        trace.log();
        return { placements };
    });
}
//# sourceMappingURL=TenantBootstrapping.js.map